export enum MarkupType {
  Amount = '$',
  Multiplier = 'x',
}
